module.exports = __webpack_public_path__ + "static/img/development-history.8f3729c.png";


//////////////////
// WEBPACK FOOTER
// ./static/cooperate/development-history.png
// module id = zxBm
// module chunks = 1